import { BookDetailPopupComponent } from './booking-detail-popup.component';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../shared/services/validation.service';
import { NgForm, FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { Utility } from '../../common/utility';
import { Appointment, PartyType } from '../../models/request-appointment/appointment.model';
import { DialogService } from '../../shared/services/dialog.service';
import { FluBookingService } from './flu-vaccine.service';
import { AppMessages } from '../../shared/constants/messages';

import * as moment from 'moment';
declare var $: any;
declare var pagescalendar: any;

@Component({
  selector: 'flu-vaccine',
  templateUrl: 'flu-vaccine.component.html',
  providers: [FluBookingService]
})
export class FluVaccineComponent implements OnInit, AfterViewInit {
  public bookingId;
  public bookingDetail: any;
  public bookingList: any;
  public bookingFluForm: FormGroup;
  public staffData = [];
  public staffId = '';
  public patientList = [];
  constructor(
    private router: Router,
    public utility: Utility,
    public activeRouter: ActivatedRoute,
    private formBuilder: FormBuilder,
    public fluBookingService: FluBookingService,
    public dialogService: DialogService) {
    this.createForm();
  }

  ngOnInit() {
    this.bookingId = this.activeRouter.snapshot.params['id'];
    this.getFluBookingInfo(this.bookingId, callback => {
      if (callback) {
        // this.bookingDetail = this.fluBookingService.getFluBookingInfo(this.bookingId);

        this.staffData = this.bookingDetail.staffs;
        this.staffId = this.bookingDetail.staffs[0].id || '';
        // this.bookingList = this.fluBookingService.getFluBookingList(this.bookingId);

        // update bookingFluForm value
        this.bookingFluForm.controls['bookingREF'].setValue(this.bookingDetail.bookingRef);
        this.bookingFluForm.controls['staffId'].setValue(this.bookingDetail.staffs[0].id);
        // this.getFluBooking(this.bookingId);
      }
    });
    this.fluBookingService.getPatientList(this.bookingId).subscribe(response => {
      if (response) {
        this.patientList = <Array<any>>response.json();
      }
    });
  }

  getFluBookingInfo(id, callback?) {
    this.fluBookingService.getFluBookingInfo(id).subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          this.bookingDetail = data;
          this.bookingDetail['bookingDate'] = moment.utc(this.bookingDetail['bookingDate']).local().format('YYYY-MM-DD');
          this.bookingDetail['disableTimes'] = this.fluBookingService.convertDisableTimeToLocalTime(this.bookingDetail['disableTimes'], this.bookingDetail['bookingDate']);
          this.getFluBookingList(id, data.staffs[0].id, callback => {
            if (callback) {
              this.initCalendar();
            }
          });
        }
        callback(true);
      },
      error => { callback(true); }
    );
  }

  getFluBookingList(id, staffId, callback?) {
    this.fluBookingService.getFluBookingList(id, staffId).subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          this.bookingList = this.fluBookingService.convertBookingListToLocalTime(data);
        }
        callback(true);
      },
      error => { callback(true); }
    );
  }

  createForm() {
    this.bookingFluForm = this.formBuilder.group({
      bookingREF: [''],
      staffId: ['', [Validators.required]],
    });
  }

  ngAfterViewInit() {

    //this.initCalendar();
  }


  initCalendar() {
    let selectedEvent;
    let self = this;
    $('#fluCalendar').pagescalendar({
      ui: {
        //Year Selector
        year: {
          visible: false,
        },
        //Month Selector
        month: {
          visible: false,
        },
        dateHeader: {
          format: 'dddd, D MMMM YYYY', //'MMMM YYYY, D dddd',
          visible: true,
        },
        //Mini Week Day Selector
        week: {
          day: {
            format: 'D'
          },
          header: {
            format: 'dd'
          },
          eventBubble: true,
          startOfTheWeek: '0',
          endOfTheWeek: '6',
          visible: false
        },
        //Week view Grid Options
        grid: {
          dateFormat: 'D dddd',
          timeFormat: 'h A',
          eventBubble: true,
          scrollToFirstEvent: false,
          scrollToAnimationSpeed: 300,
          scrollToGap: 20
        }
      },
      events: self.bookingList,
      now: self.bookingDetail.bookingDate,
      view: 'day',
      timeFormat: 'h:mm A',
      slotDuration: self.bookingDetail.bookingDuration, // 5 minutes per slot
      disableDates: self.bookingDetail.disableDates,
      disableTimes: self.bookingDetail.disableTimes,
      eventOverlap: false,
      onTimeSlotDblClick: function (target, timeSlot) {
        // if there is a booking event on that slot then return
        if ($(target).children().length > 0) {
          return;
        }
        const datetime = {
          bookingId: self.bookingId,
          staffId: self.staffId,
          startTime: self.fluBookingService.convertBookingDateToUTCString(timeSlot.date),
          clientStartTime: timeSlot.date,
          time: moment(timeSlot.date).format('hh:mmA') + " - " +
            moment(timeSlot.date).add(self.bookingDetail.bookingDuration, 'minutes').format('hh:mmA'),
          patientList: self.patientList
        };
        self.dialogService.openComponentDialog(BookDetailPopupComponent, datetime).subscribe(
          result => {
            if (result) {
              // Adding a new Event on Slot Double Click when API success
              const newEvent = result;
              self.fluBookingService.convertBookingItemToLocalTime(newEvent);
              self.bookingList.push(newEvent);
              newEvent['index'] = this.events.length - 1;
              // self.dialogService.openSuccessDialog({ message: data.message.message });
              selectedEvent = newEvent;
              $('#fluCalendar').pagescalendar('addEvent', newEvent);
            }
          });
      },
      onViewRenderComplete: function () {
        let $availableSlot = $('.tcell.active .cell-inner:not(.disable)').first();
        if ($availableSlot) {
          $availableSlot.attr('id', 'tmb-available-slot');
          setTimeout(() => self.scrollToAvailableSlot(self), 50);
        }
      }
    });
  }

  scrollToAvailableSlot(self) {
    $('html').animate({
      scrollTop: $("#tmb-available-slot").offset().top - 50
    }, 500, function () {
      // Animation complete show notifitation popup
      $(this).addClass('tmb-scrollblock');
      self.dialogService.openNotificationDialog({ message: AppMessages.flu.notification }).subscribe(
        result => {
          $(this).removeClass('tmb-scrollblock');
        }
      );
    });
  }

  onChangeStaff(event) {
    this.staffId = event.target.value;
    this.getFluBookingList(this.bookingId, event.target.value, callback => {
      if (callback) {
        $('#fluCalendar').pagescalendar('removeAllEvents');
        $('#fluCalendar').pagescalendar('addEvents', this.bookingList);
      }
    });
  }

}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/flu-vaccine/flu-vaccine.component.ts